var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegend0103(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.075 17v-1.372h-2.576a17.4 17.4 0 0 0-1.68.098c2.184-2.086 3.766-4.144 3.766-6.132 0-1.862-1.218-3.094-3.108-3.094-1.344 0-2.254.588-3.136 1.54l.91.896c.546-.63 1.218-1.148 2.03-1.148 1.148 0 1.75.77 1.75 1.89 0 1.694-1.568 3.696-4.606 6.384V17h6.65zm6.439 0v-2.772h1.316v-1.246h-1.316V6.696h-1.862L20.55 13.15v1.078h4.452V17h1.512zm-1.512-4.018h-2.828l2.03-3.108c.294-.532.574-1.064.826-1.582h.056c-.028.56-.084 1.428-.084 1.988v2.702zm6.718 4.2c2.016 0 3.332-1.792 3.332-5.376 0-3.556-1.316-5.306-3.332-5.306-2.03 0-3.332 1.736-3.332 5.306 0 3.584 1.302 5.376 3.332 5.376zm0-1.274c-1.05 0-1.792-1.12-1.792-4.102 0-2.954.742-4.032 1.792-4.032s1.792 1.078 1.792 4.032c0 2.982-.742 4.102-1.792 4.102z",
    fill: "#6E1F1F",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegend0103);
export default __webpack_public_path__ + "static/media/icon-legend-01-03.53b4f7f2731153a36b2afd78b7c7a829.svg";
export { ForwardRef as ReactComponent };